import React from "react";
import { DatePicker, Input, Select } from "antd";
const { RangePicker } = DatePicker;

const CandidaturaFilter = ({ filters, onChange, provincias=[], cargos=[] }) => {

  const handle = (key, val) => onChange(prev => ({...prev, [key]: val}));

  return (
    <div className="row filter-row space">
      <div className="col-sm-4 col-md-3">
        <div className="input-block mb-3 form-focus focused">
          <Input
            value={filters.nome}
            onChange={(e)=>handle("nome", e.target.value)}
            placeholder="Nome do candidato"
            className="form-control"
          />
          <label className="focus-label">Nome</label>
        </div>
      </div>

      <div className="col-sm-3 col-md-2">
        <div className="input-block form-focus select-focus">
          <Select
            allowClear
            className="w-100 form-control"
            placeholder="Província"
            value={filters.provincia || undefined}
            onChange={(v)=>handle("provincia", v || "")}
            options={provincias.map(p=>({label:p, value:p}))}
          />
          <label className="focus-label">Província</label>
        </div>
      </div>

      <div className="col-sm-3 col-md-2">
        <div className="input-block form-focus select-focus">
          <Select
            allowClear
            className="w-100 form-control"
            placeholder="Cargo pretendido"
            value={filters.cargo || undefined}
            onChange={(v)=>handle("cargo", v || "")}
            options={cargos.map(c=>({label:c, value:c}))}
          />
          <label className="focus-label">Cargo</label>
        </div>
      </div>

      <div className="col-sm-3 col-md-2">
        <div className="input-block form-focus select-focus">
          <Select
            className="w-100 form-control"
            value={filters.estado}
            onChange={(v)=>handle("estado", v)}
            options={[
              {label:"Todos", value:"ALL"},
              {label:"Ativos (pipeline)", value:"ATIVOS"},
              {label:"Reprovados", value:"REPROVADOS"},
            ]}
          />
          <label className="focus-label">Estado</label>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="input-block form-focus">
          <RangePicker
            className="w-100 form-control"
            value={filters.dataRange}
            onChange={(v)=>handle("dataRange", v)}
          />
          <label className="focus-label">Período</label>
        </div>
      </div>
    </div>
  );
};

export default CandidaturaFilter;
